import React from 'react';

interface DoubleCheckMarkProps {
  width?: string;
  color?: string;
}

const DoubleCheckMark: React.FC<DoubleCheckMarkProps> = ({
  width = '24px',
  color = 'currentColor',
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 9.33333L3.23309 10.7582C3.66178 11.0797 4.26772 11.0061 4.60705 10.5914L10 4"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46973 11.0158L7.58232 11.1059C8.22419 11.6194 9.15977 11.5207 9.68029 10.8845L15.054 4.31663C15.2288 4.10291 15.1973 3.7879 14.9836 3.61304C14.7699 3.43817 14.4549 3.46967 14.28 3.6834L8.90634 10.2512C8.73283 10.4633 8.42097 10.4962 8.20701 10.325L8.103 10.2418L7.46973 11.0158Z"
        fill={color}
      />
    </svg>
  );
};

export default DoubleCheckMark;
